import api, { adminApiPrefix } from './Api';
import {
  HepsiburadaOrderFilter,
  hepsiburadaOrderFilterToQueryParams,
} from '../interfaces/Hepsiburada/HepsiburadaOrderFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  HepsiburadaOrder,
  hepsiburadaOrderFromResponse,
} from '../interfaces/Hepsiburada/HepsiburadaOrder';

const hepsiburadaAdminApiPrefix = `${adminApiPrefix}/hepsiburada`;

export const getHepsiburadaOrders = async (
  filter: HepsiburadaOrderFilter,
): Promise<PaginatedResponse<HepsiburadaOrder>> => {
  const response = await api.get(`${hepsiburadaAdminApiPrefix}/orders`, {
    params: hepsiburadaOrderFilterToQueryParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((order: any) =>
      hepsiburadaOrderFromResponse(order),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const checkHepsiburadaStatus = async (): Promise<void> =>
  api.get(`${hepsiburadaAdminApiPrefix}/status`);
